/**
 * sorting rows of a table using a column
 * @param rows the rows of the table
 * @param answers the answers for the rows (columns)
 * @param identifier the sort identifier
 * @param sortAsc if true we want to sort ascending
 * @return {*[]|*}
 */
export const sortRows = (rows, answers, identifier, sortAsc) => {
  let sortItems = [];
  answers.forEach((answer) => {
    if (answer.colLabel === identifier) {
      sortItems.push({
        rowId: answer.label,
        sortProperty: answer.text
      });
    }
  });
  sortItems.sort(function (a, b) {
    return a.sortProperty < b.sortProperty ? -1 : a.sortProperty > b.sortProperty ? 1 : 0;
  });
  if (!sortAsc) {
    sortItems.sort().reverse();
  }

  let result = [];

  sortItems.forEach((key) => {
    let found = false;
    rows = rows.filter((row) => {
      if (!found && row.id === key.rowId) {
        result.push(row);
        found = true;
        return false;
      }
      return true;
    });
  });
  result = result.concat(rows);

  return result.length > 0 ? result : rows;
};
